import { Avatar, Badge } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import { IShoppingCartInfoProps } from "../../models/interface/IShoppingCartInfoProps";
import { DefaultImg } from "../../components/images";
import OrderVoucherCode from "../../components/orderVoucherCode";
import { PROPERTY_TYPE } from "../../common/constant";
import { renderTotalAmount } from "../../shared/helpers";

const ShoppingCartInfo = (props: IShoppingCartInfoProps) => {
  const { t, carts } = props;

  return (
    <div className="checkout-carts-wrapper">
      <div className="checkout-carts-items">
        {carts?.items?.map((item, i) => (
          <div key={item._id} className="carts-item-wrapper">
            <div className="carts-item-product-wrapper">
              <div className="carts-product-info-wrapper">
                <div className="carts-product-img">
                  <Badge count={item.quantity}>
                    <Avatar size={64} shape="square" src={item.product?.img} />
                  </Badge>
                </div>
                <div className="carts-product-info">
                  <span className="product-name">{item.product.name}</span>
                  {renderMoreProperty(item.product_property)}
                  <span className="product-spec">
                    {item.product?.feature?.spec}
                  </span>
                </div>
              </div>
              <div className="carts-item-product-price">
                <span className="product-price">
                  {item.sub_total_amount} VND
                </span>
              </div>
            </div>
            <div className="carts-item-gifts">
              {item?.gift_promotions?.map((gift, j) => (
                <div key={gift._id} className="carts-item-gift">
                  <div className="carts-product-info-wrapper">
                    <div className="carts-product-img">
                      <Avatar
                        size={32}
                        shape="square"
                        src={gift.product?.img ? gift.product?.img : DefaultImg}
                      />
                    </div>
                    <div className="carts-product-info">
                      <span className="product-name">{gift.product.name}</span>
                      <span className="product-spec">
                        {gift.product_name_extra}
                      </span>
                    </div>
                  </div>
                  {/* <div className="carts-item-product-price">
                    <span className="product-price">
                      {gift.sealed_price} VND
                    </span>
                  </div> */}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div>
        <OrderVoucherCode />
        {/* <div className="shopping-cart-summary-wrapper">
          <div className="shopping-cart-summary-item">
            <span className="shopping-cart-summary-item-label">
              {t("shopping_cart_sub_total_amount")}
            </span>
            <span className="shopping-cart-summary-item-value">
              {carts.sub_total_amount}
            </span>
          </div>
          <div className="shopping-cart-summary-item">
            <span className="shopping-cart-summary-item-label">
              {t("shopping_cart_total_amount_discount")}
            </span>
            <span className="shopping-cart-summary-item-value">
              {carts.total_amount_discount
                ? carts.total_amount_discount
                : "0 VNĐ"}
            </span>
          </div>
        </div> */}
        <div className="shopping-cart-checkout-wrapper">
          {!!(
            carts.order_discount_amount && carts.order_discount_amount !== 0
          ) && (
            <div className="shopping-cart-summary-item">
              <span className="shopping-cart-summary-item-label order_discount_amount">
                {t("order_discount_amount")}
              </span>
              <span
                className={`shopping-cart-summary-item-sub-value order_discount_amount`}>
                {`-${carts.order_discount_amount.toLocaleString("vi-VN")} VND`}
              </span>
            </div>
          )}

          <div className="shopping-cart-summary-item shopping-cart-total-amount">
            <span className="shopping-cart-summary-item-label">
              {t("shopping_cart_total_amount")}
            </span>
            <span
              className="shopping-cart-summary-item-value"
              style={{ color: "#fe3834" }}>
              {renderTotalAmount(carts.total_amount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const renderMoreProperty = (property: any) => {
  let displayValue = "";

  if (property) {
    if (property[PROPERTY_TYPE.image]) {
      displayValue = property[PROPERTY_TYPE.image].label;
    }

    if (property[PROPERTY_TYPE.cover]) {
      displayValue = property[PROPERTY_TYPE.cover].label;
    }

    if (property[PROPERTY_TYPE.foam]) {
      displayValue = property[PROPERTY_TYPE.foam].label;
    }
  }

  return <span className="product-spec sub-content">{displayValue}</span>;
};

export default withTranslation()(ShoppingCartInfo);
